/**
 * @file index.tsx
 *
 * @fileoverview Fixed main navigation for the website / header.
 */

import { cva } from "class-variance-authority";
import { ReactNode } from "react";
import { useScrollYPosition } from "../../../../hooks/useScrollPosition";
import styles from "./headerFixed.module.scss";

export const FIXED_SCROLLING_SHOW_HEADER = 100;

const fixedNavblock = cva([styles.fixedNavblock], {
  variants: {
    shown: {
      true: styles.fixedNavigationShown,
      false: styles.fixedNavigationHidden,
    },
  },
});

export interface FixedNavbarProps {
  /**
   * The content to go inside the header.
   */
  children?: ReactNode;
}

/**
 * Fixed site navigation / header. Should be used to include the main navigation for the site in some pages, when scroll to amount specified will transition to fixed positioned (sticky)
 * branding of the website.
 */
export default function FixedNavbar({ children }: FixedNavbarProps) {
  const scrollY = useScrollYPosition();

  return (
    <div
      className={fixedNavblock({
        shown: scrollY > FIXED_SCROLLING_SHOW_HEADER,
      })}
      id="fixed-navbar"
      data-testid="fixed-navbar"
    >
      <div className={styles.fixedNavContainer}>{children}</div>
    </div>
  );
}

export { FixedNavbar };
